import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './env-var.reducer';

export const EnvVarDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const envVarEntity = useAppSelector(state => state.envVar.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="envVarDetailsHeading">
          <Translate contentKey="tycheApp.envVar.detail.title">EnvVar</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{envVarEntity.id}</dd>
          <dt>
            <span id="level">
              <Translate contentKey="tycheApp.envVar.level">Level</Translate>
            </span>
          </dt>
          <dd>{envVarEntity.level}</dd>
          <dt>
            <span id="key">
              <Translate contentKey="tycheApp.envVar.key">Key</Translate>
            </span>
          </dt>
          <dd>{envVarEntity.key}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tycheApp.envVar.value">Value</Translate>
            </span>
          </dt>
          <dd>{envVarEntity.value}</dd>
          <dt>
            <span id="orgId">
              <Translate contentKey="tycheApp.envVar.orgId">Org Id</Translate>
            </span>
          </dt>
          <dd>{envVarEntity.orgId}</dd>
          <dt>
            <span id="flowId">
              <Translate contentKey="tycheApp.envVar.flowId">Flow Id</Translate>
            </span>
          </dt>
          <dd>{envVarEntity.flowId}</dd>
        </dl>
        <Button tag={Link} to="/env-var" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/env-var/${envVarEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EnvVarDetail;
